<template>
  <hm-content>
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="关键词自动回复" name="first"></el-tab-pane>
      <el-tab-pane label="关注后自动回复" name="second"></el-tab-pane>
    </el-tabs>
    <div class="p20" v-show="activeName === 'first'">
      <div class="table-panel flex flex-between">
        <div>
          <el-button type="primary" size="small" @click="addAutoReply"
            >新建自动回复</el-button
          >
        </div>
        <div>
          <el-input
            clearable
            v-model.trim="keyword"
            placeholder="输入关键词"
            size="small"
            class="ipt mr10"
          ></el-input>
          <el-button type="primary" size="small" @click="search"
            >查询</el-button
          >
        </div>
      </div>
      <div class="table mb20">
        <el-table
          stripe
          border
          ref="brandTable"
          :data="records"
          style="width: 100%"
          id="table"
          size="small"
        >
          <el-table-column
            type="index"
            label="序号"
            :index="index => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="name"
            label="规则名称"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="keyWord"
            show-overflow-tooltip
            label="关键词"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="keyWordReply"
            label="回复方式"
          ></el-table-column>
          <el-table-column header-align="center" align="center" label="状态">
            <template slot-scope="scope">
              <span class="success" v-show="scope.row.status === 1">启用</span>
              <span class="danger" v-show="scope.row.status === 0">停用</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="150"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <div class="flex flex-center">
                <el-tooltip
                  class="item"
                   
                  :content="scope.row.status === 0 ? '停用' : '启用'"
                  placement="top"
                >
                  <div class="pointer mr10" @click="disableKeyword(scope.row)">
                    <span class="hmicon icon-tingyongdefuben blue"></span>
                  </div>
                </el-tooltip>
                <el-tooltip
                  class="item"
                   
                  content="编辑"
                  placement="top"
                >
                  <div
                    class="pointer mr10"
                    @click="edit(scope.row)"
                    v-show="scope.row.auditState !== 'audit_pass'"
                  >
                    <span class="hmicon icon-bianji blue"></span>
                  </div>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="hm-pagination mb20">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
    <div class="p20" v-show="activeName === 'second'">
      <el-form ref="ruleForm" label-width="100px">
        <el-form-item label="回复类型">
          <el-radio-group
            v-model="ruleForm.replyType"
            size="small"
            @change="switchReplyType"
          >
            <el-radio :label="0">文字</el-radio>
            <el-radio :label="1">图片</el-radio>
            <el-radio :label="2">图文消息</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="文本" v-if="ruleForm.replyType !== 1">
          <el-input type="textarea" v-model="ruleForm.contents"></el-input>
        </el-form-item>
        <el-form-item label="图片" v-if="ruleForm.replyType !== 0">
          <div class="flex upload-upload-btn" @click="show = true">
            <div
              v-if="!ruleForm.img"
              class="btn flex flex-column flex-center open-file"
            >
              <div class="add-wrapper">
                <span class="hmicon icon-hao pointer"></span>
              </div>
              <span>添加图片</span>
            </div>
            <div v-if="ruleForm.img" class="mr10 flex item-end img-wrapper">
              <img class="logo" :src="ruleForm.img" alt="logo" />
            </div>
          </div>
        </el-form-item>
        <el-form-item label="跳转链接">
          <el-input type="text" size="small" v-model="ruleForm.url"></el-input>
        </el-form-item>
      </el-form>
      <div class="btn-wrapper mb20 flex flex-center">
        <el-button size="small" type="primary" @click="save">确定</el-button>
      </div>
    </div>
    <my-upload
      field="file"
      @crop-upload-success="cropUploadSuccess"
      v-model="show"
      noCircle
      noSquare
      :headers="{ 'X-Access-Token': $token }"
      :params="{ fileDir: 'goodsCenter' }"
      :url="$uploadUrl"
      img-format="png"
    ></my-upload>
  </hm-content>
</template>

<script>
 import myUpload from "vue-image-crop-upload";

export default {
  components: {
     
    myUpload
  },
  data() {
    return {
      show: false,
      ruleForm: {
        replyType: 0,
        contents: "",
        img: "",
        url: ""
      },
      activeName: "first",
      autoReplyContent: "",
      total: 0,
      keyword: "",
      currentPage: 1,
      pageSize: 10,
      records: []
    };
  },
  computed: {},
  watch: {},
  created() {
    this.queryReplyList();
  },
  mounted() {},
  methods: {
    async queryReplyList() {
      const { result } = await this.$store.dispatch("queryReplyList", {
        keyword: this.keyword,
        currentPage: 1,
        pageSize: 10,
      });
      this.records = result.records;
      this.total = result.total;
    },
    switchReplyType() {
      this.ruleForm.contents = "";
      this.ruleForm.img = "";
      this.ruleForm.url = "";
    },
    async save() {
      const params = {
        wxKeyWordRuleBo: {
          name: "关注回复",
          status: 1,
          type: 0
        },
        wxKeyWordBo: [{ keyword: "subscribe", matchType: 1 }],
        wxKeyWordReplyBo: [this.ruleForm]
      };
      const { code } = await this.$store.dispatch("addReply", params);
      if (code === 0) {
        this.$message({
          message: " 操作成功",
          type: "success"
        });
        this.queryReplyList();
        this.activeName = "first";
      }
    },
    close() {},
    async disableKeyword(row) {
      const { code } = await this.$store.dispatch("switchReplyStatus", {
        keyWordRuleId: row.keyWordRuleId,
        status: row.status === 0 ? 1 : 0
      });
      if (code === 0) {
        this.$message({
          message: "操作成功",
          type: "success"
        });
        this.queryReplyList();
      }
    },
    search() {
      this.queryReplyList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryReplyList();
    },
    cropUploadSuccess(jsonData) {
      this.ruleForm.img = jsonData.result;
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryReplyList();
    },
    addAutoReply() {
      this.$router.push({ name: "AddKeywordReply" });
    },
    edit(row) {
      this.$router.push({
        name: "EditKeywordReply",
        query: {
          keyWordRuleId: row.keyWordRuleId
        }
      });
    },
    handleClick() {}
  }
};
</script>
<style lang="scss" scoped>
.upload-upload-btn {
  .tips {
    color: #999;
    font-size: 12px;
    line-height: 20px;
  }

  .img-wrapper {
    border: 1px dashed #f5f5f5;
    width: 102px;
    position: relative;
    img {
      width: 100%;
    }
    &::after {
      position: absolute;
      content: "更换图片";
      bottom: 0;
      left: 0;
      right: 0;
      background: rgba(0, 0, 0, 0.5);
      color: #fff;
      font-size: 12px;
      text-align: center;
      height: 30px;
      line-height: 30px;
    }
  }

  .btn {
    border: 1px solid #ddd;
    text-align: center;
    padding: 10px;
    margin-right: 10px;
    width: 80px;
    height: 80px;
    cursor: pointer;
    .add-wrapper {
      width: 30px;
      height: 30px;
      line-height: 30px;
      background: #e50065;
      color: #fff;
      text-align: center;
      border-radius: 50%;
      margin: 0 auto;
      span {
        font-size: 12px;
      }
      cursor: pointer;
      .hmicon {
        font-size: 14px;
      }
    }
  }
}
</style>
